import { useInfiniteQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { _3_DAYS } from "../../../constants/durations";
import { useSpace } from "../../../hooks/useSpace";
import { PendingSubTopicWithPreview } from "../../../types";
import { getNextPageIndex } from "../../../utils/pagination";
import { keys } from "./keys";

const PENDING_SUB_TOPICS_PAGE_SIZE = 10;

async function fetchPendingSubTopicsWithPreview(spaceId: string, pageIndex: number): Promise<PendingSubTopicWithPreview[]> {
  const { data, error } = await apiClient.rpc('get_pending_sub_topics_with_preview', {
    _space_id: spaceId,
    _limit: PENDING_SUB_TOPICS_PAGE_SIZE,
    _offset: pageIndex * PENDING_SUB_TOPICS_PAGE_SIZE,
  });

  if (error) {
    throw error;
  }

  return (data ?? []) as unknown as PendingSubTopicWithPreview[];
}

export function useGetPendingSubTopicList() {
  const { currentSpace } = useSpace();

  return useInfiniteQuery({
    queryKey: keys.pendingSubTopics(currentSpace?.id ?? ''),
    queryFn: ({ pageParam }) => fetchPendingSubTopicsWithPreview(currentSpace!.id, pageParam),
    initialPageParam: 0,
    getNextPageParam: getNextPageIndex(PENDING_SUB_TOPICS_PAGE_SIZE),
    enabled: !!currentSpace?.id,
    staleTime: _3_DAYS,
  });
}
